import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer/Footer"
import FormCheck from "../components/FormCheck/FormCheck"
import NavBar from "../components/NavBar/NavBar"
import { useSelector } from "react-redux";
import { useEffect } from "react";
import axios from "axios";
import URLPage from "../endPoints/endpoints";
import Spinner from "../components/Spinner/Spinner";


// Validate Token

function AddReport() {

    const user  = useSelector(state => state.us.current?.token);
    const navigate = useNavigate()
    useEffect(() => {
       
       if(!user) {
        navigate('/');
        window.location.reload();
        return 
        }else {
         axios.get(`${URLPage}/api/users/validate-user`, {
         headers: 
       {
        'x-token': user
        }
   })
   .then(res => {
    
  })
  .catch(err => {
   navigate('/');
   window.location.reload();
  });
      }
     
    }, []);
    

    return <>
     <div className="page-container">

      <div >
      <NavBar  title='Add Report' />
      </div> 
    
      <div className="content-wrap">
      <FormCheck/>
      </div>
     
     <Footer/>
     </div>
    </>
}

export default AddReport